<app-auth-navbar></app-auth-navbar>

<main class="rtl">
  <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
    <div class="absolute top-0 w-full h-full bg-center bg-cover"
      style="background-image: url('../../../assets/img/03.jpg');">
      <span class="w-full h-full absolute" id="blackOverlay"></span>
    </div>
    <div class="container relative mx-auto">
      <div class="items-center flex flex-wrap">
        <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
          <div class="">
            <h1 class="text-white font-semibold text-5xl leading-normal">
              استاد ویزیت، سامانه ویزیت و مشاوره آنلاین پزشکی
            </h1>
            <app-search></app-search>

          </div>
        </div>
      </div>
    </div>
  </div>

  <!--START SERVICES SETION -->
  <section class="bg-white">
    <div class="container mx-auto px-4">
      <div class="services-sec flex flex-wrap">
        <div class="pt-6 w-full md:w-3/12 px-4">
          <div class="relative flex min-w-0 break-words w-full mb-8 rounded-lg">
                <img src="../../../assets/img/chat-visit.svg" class="w-4/12" alt="">
            <div class="py-5 flex-auto">
              <!-- <div class="text-center inline-flex items-center justify-center h-16 mt-2">
              </div> -->
              <h2 class="text-xl font-semibold"> مشاوره متنی </h2>
              <p class="mt-2 mb-4 text-blueGray-500">
                گفتگوی متنی با پزشک
              </p>
            </div>
          </div>
        </div>

        <div class="pt-6 w-full md:w-3/12 px-4">
          <div class="relative flex min-w-0 break-words w-full mb-8 rounded-lg">
                <img src="../../../assets/img/video-visit.svg" class="w-4/12" alt="">
            <div class="py-5 flex-auto">
              <!-- <div class="text-center inline-flex items-center justify-center h-16 my-2">
              </div> -->
              <h2 class="text-xl font-semibold"> ویزیت تصویری </h2>
              <p class="mt-2 mb-4 text-blueGray-500">
                گفتگوی تصویری با پزشک
              </p>
            </div>
          </div>
        </div>

        <div class="pt-6 w-full md:w-3/12 px-4">
          <div class="relative flex min-w-0 break-words w-full mb-8 rounded-lg">
                <img src="../../../assets/img/call-visit.svg" class="w-4/12" alt="">
            <div class="py-5 flex-auto">
              <!-- <div class="text-center inline-flex items-center justify-center h-16 mt-2">
              </div> -->
              <h2 class="text-xl font-semibold"> ویزیت صوتی </h2>
              <p class="mt-2 mb-4 text-blueGray-500">
                گفتگوی صوتی با پزشک
              </p>
            </div>
          </div>
        </div>

        <div class="pt-6 w-full md:w-3/12 px-4">
          <div class="relative flex min-w-0 break-words w-full mb-8 rounded-lg">
                <img src="../../../assets/img/in-person-visit.svg" class="w-4/12" alt="">
            <div class="py-5 flex-auto">
              <!-- <div class="text-center inline-flex items-center justify-center h-16 mt-2">
              </div> -->
              <h2 class="text-xl font-semibold"> ویزیت حضوری </h2>
              <p class="mt-2 mb-4 text-blueGray-500">
                گفتگوی حضوری با پزشک
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END OF SERVICES SECTION -->

  <!-- START DOCTORS SECTION -->
  <section class="pt-32 py-16 main-bg">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-between mb-6 px-4">
          <h2 class="text-3xl font-semibold"> پزشکان ما </h2>
          <a routerLink="/doctors-list" class="text-xl"> مشاهده بیشتر </a>
          <!-- <p class="text-lg leading-relaxed m-4 text-blueGray-500">
              According to the National Oceanic and Atmospheric Administration,
              Ted, Scambos, NSIDClead scentist, puts the potentially record
              maximum.
            </p> -->
      </div>
      <div class="lg:flex">
        <div class="w-full lg:w-6/12 xl:w-4/12 pl-2 pr-4">
          <div class="relative doctor-custom-card flex flex-col break-words rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <div class="py-4 text-center">
              <h3 class="text-xl font-bold text-white"> استاد ویزیت، راه ارتباطی شما با مجرب‌ترین پزشکان کشور. </h3>
              <div class="inline-flex py-8">
                <img alt="..." src="assets/img/a5beb92e-74b7-4f4e-bc74-5b013b903e34.webp" class="shadow-lg rounded-full mx-auto h-16 w-16"
                  style="left: -14px; position: relative;" />
                <img alt="..." src="assets/img/4f69efe8-b8a8-4961-9336-bab27cf62ce0.png" class="shadow-lg rounded-full mx-auto h-16 w-16"
                  style="left: -7px; position: relative;" />
                <img alt="..." src="assets/img/edad46e0-0d26-46ec-b156-c9fc24c9c80b.jpg" class="shadow-lg rounded-full mx-auto h-16 w-16"
                  style="left: -2px; position: relative;" />
                <img alt="..." src="assets/img/fb7ddd8b-4d75-4d5e-9f35-df8f21e66aec.jpg.png" class="shadow-lg rounded-full mx-auto h-16 w-16"
                  style="left: 5px; position: relative;" />
              </div>
              <div class="mt-4">
                <button class="bg-transparent border-white border-2 text-white w-auto rounded-md px-6 py-2"
                  type="button" routerLink="/doctors-list"> همه پزشکان
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="carousel-section">
          <div class="carousel-container">
            <div class="carousel-wrapper flex" [style.transform]="'translateX(+' + currentIndex * 100 + '%)'">
              <div class="carousel-slide w-full" *ngFor="let slide of doctors">
                <div class="card shadow rounded bg-white text-center">
                  <img class="shadow rounded-full mx-auto max-w-100-px max-h-100-px" loading="lazy"
                    onerror="this.onerror=null; this.src='../../../assets/img/thumb-profile1.svg.png';"
                    [src]="slide.profilePic?apiService.api+slide.profilePic:'../../../assets/img/thumb-profile1.svg.png'" >
                  <div class="card-body">
                    <h4 class="text-xl font-bold mt-4">{{ slide.name }} {{slide.family}} </h4>
                    <p class="mt-2 mx-2 min-h-10 text-sm text-blueGray-400 uppercase font-semibold">{{ slide.medicalEspertiseName }}</p>
                    <div class="mt-6">
                      <button class="bg-primary text-white w-1/2 h-8 rounded outline-none focus:outline-none mb-1"
                        type="button" [routerLink]="['doctor-detail/'+slide.id]"> دریافت نوبت
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- carousel control -->
            <div class="carousel-header">
              <div class="carousel-controls">
                <button (click)="updateCarousel(1)"
                  class="carousel-btn cursor-pointer rounded-full bg-white shadow disabled:bg-transparent disabled:cursor-auto">
                  <img src="../../../assets/img/icon/keyboard_arrow_left.svg" alt="">
                </button>
                <button (click)="updateCarousel(-1)"
                  class="carousel-btn cursor-pointer rounded-full bg-white shadow disabled:bg-transparent disabled:cursor-auto">
                  <img src="../../../assets/img/icon/keyboard_arrow_right.svg" alt="">
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- <div *ngFor="let doc of doctors" class="w-22-p px-2">
            <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
              <img alt="..." [src]="doc.pic" class="shadow-lg rounded-full mx-auto max-w-120-px" />
              <div class="pt-6 text-center">
                <h5 class="text-xl font-bold"> {{doc?.name}} </h5>
                <h5 *ngIf="error">{{ error }}</h5>
                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                  {{doc.specialty}}
                </p>
                <div class="mt-6">
                  <button class="bg-primary text-white w-1/2 h-8 rounded-sm outline-none focus:outline-none mb-1"
                    type="button">   دریافت نوبت
                  </button>                
                </div>
              </div>
            </div>
          </div>  -->


      </div>
    </div>
  </section>
  <!-- END OF DOCTORS SECTION -->

  <!-- START SPECIALTY SECTION -->
  <section class="py-16 main-bg">
    <div class="container mx-auto p-8">
      <div class="p-6 bg-primary-light">
      <div class="flex flex-wrap justify-between px-4 mb-4">
          <h2 class="text-3xl font-semibold"> تخصص های پر تکرار </h2>
          <!-- <a routerLink="" class="text-xl"> مشاهده بیشتر </a> -->
      </div>
      <div class="flex flex-wrap">
        <!-- <div *ngFor="let cat of medicalCategory" class="w-full lg:w-4/12 xl:w-2/12 p-3" (click)="searchByCategory(cat.name)">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow">
            <img alt="..." [src]="cat.img?apiService.api+cat.img:'../../../assets/img/default-profile.png'" class="mx-auto max-w-100-px" />
            <div class="py-6 text-center">
              <h3 class="text-lg font-bold"> {{cat.name}} </h3>
            </div>
          </div>
        </div> -->
        <div class="w-full lg:w-4/12 xl:w-2/12 p-3">
          <button class="w-full" (click)="onSearch('قلب')"  >
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow hover:shadow-lg">
            <img alt="..." src="../../../assets/img/heart-2.png" class="mx-auto w-20" />
            <div class="py-6 text-center">
              <h3 class="text-lg font-bold"> قلب </h3>
            </div>
          </div>
          </button>
        </div>
        <div class="w-full lg:w-4/12 xl:w-2/12 p-3">
          <button class="w-full" (click)="onSearch('مغز')"  >
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow hover:shadow-lg">
            <img alt="..." src="../../../assets/img/brain-1.png" class="mx-auto w-20" />
            <div class="py-6 text-center">
              <h3 class="text-lg font-bold"> مغز و اعصاب </h3>
            </div>
          </div>
          </button>
        </div>
        <div class="w-full lg:w-4/12 xl:w-2/12 p-3">
          <button class="w-full" (click)="onSearch('عفونی')"  >
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow hover:shadow-lg">
            <img alt="..." src="../../../assets/img/virus-1.png" class="mx-auto w-20" />
            <div class="py-6 text-center">
              <h3 class="text-lg font-bold"> عفونی </h3>
            </div>
          </div>
          </button>
        </div>
        <div class="w-full lg:w-4/12 xl:w-2/12 p-3">
          <button class="w-full" (click)="onSearch('ریه')"  >
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow hover:shadow-lg">
            <img alt="..." src="../../../assets/img/lung-2.png" class="mx-auto w-20" />
            <div class="py-6 text-center">
              <h3 class="text-lg font-bold"> ریه </h3>
            </div>
          </div>
          </button>
        </div>
        <div class="w-full lg:w-4/12 xl:w-2/12 p-3">
          <button class="w-full" (click)="onSearch('تغذیه')"  >
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow hover:shadow-lg">
            <img alt="..." src="../../../assets/img/taghzieh.png" class="mx-auto w-20" />
            <div class="py-6 text-center">
              <h3 class="text-lg font-bold"> تغذیه </h3>
            </div>
          </div>
          </button>
        </div>
      </div>
      </div>
    </div>
  </section>
  <!-- END OF SPECIALTY SECTION -->

  <!-- START BLOG SECTION -->
  <section class="py-16 main-bg">
    <div class="container mx-auto p-4">
      <div class="flex flex-wrap justify-between px-4 mb-4">
        <h2 class="text-3xl font-semibold"> مجله سلامت </h2>
        <a routerLink="/blog" class="text-xl"> مشاهده بیشتر </a>
      </div>
      <div class="flex flex-wrap">
        <div *ngFor="let blog of blogList" class="w-full lg:w-6/12 xl:w-4/12 p-4">
          <a [routerLink]="['/blog-detail/'+blog.id]">
            <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow hover:shadow-lg">
              <img loading="lazy" alt="..." [src]="blog.img?apiService.api+blog.img:'../../../assets/img/default-profile.png'" class="shadow-lg w-full h-180-px rounded" />
              <div class="pt-6">
                <h3 class="font-bold" style="min-height: 50px;"> {{blog.title}} </h3>
                <p class="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                  {{blog.authorPost}}
                </p>
                <div class="flex mt-6 border-t">
                  <img class="w-8 p-1" src="../../../assets/img/icon/calendar_ion.svg" alt=""> <span
                    class="text-gray-500 pt-1"> {{blog.createDate | shamsiDate}} </span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- END OF BLOG SECTION -->


  <!-- <section class="pb-20 relative block bg-blueGray-800">
    <div class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
      style="transform: translateZ(0)">
      <svg class="absolute bottom-0 overflow-hidden" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"
        version="1.1" viewBox="0 0 2560 100" x="0" y="0">
        <polygon class="text-blueGray-800 fill-current" points="2560 0 2560 100 0 100"></polygon>
      </svg>
    </div>

    <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
      <div class="flex flex-wrap text-center justify-center">
        <div class="w-full lg:w-6/12 px-4">
          <h2 class="text-4xl font-semibold text-white">Build something</h2>
          <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400">
            Put the potentially record low maximum sea ice extent tihs year down
            to low ice. According to the National Oceanic and Atmospheric
            Administration, Ted, Scambos.
          </p>
        </div>
      </div>
      <div class="flex flex-wrap mt-12 justify-center">
        <div class="w-full lg:w-3/12 px-4 text-center">
          <div
            class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
            <i class="fas fa-medal text-xl"></i>
          </div>
          <h6 class="text-xl mt-5 font-semibold text-white">
            Excelent Services
          </h6>
          <p class="mt-2 mb-4 text-blueGray-400">
            Some quick example text to build on the card title and make up the
            bulk of the card's content.
          </p>
        </div>
        <div class="w-full lg:w-3/12 px-4 text-center">
          <div
            class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
            <i class="fas fa-poll text-xl"></i>
          </div>
          <h5 class="text-xl mt-5 font-semibold text-white">
            Grow your market
          </h5>
          <p class="mt-2 mb-4 text-blueGray-400">
            Some quick example text to build on the card title and make up the
            bulk of the card's content.
          </p>
        </div>
        <div class="w-full lg:w-3/12 px-4 text-center">
          <div
            class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center">
            <i class="fas fa-lightbulb text-xl"></i>
          </div>
          <h5 class="text-xl mt-5 font-semibold text-white">Launch time</h5>
          <p class="mt-2 mb-4 text-blueGray-400">
            Some quick example text to build on the card title and make up the
            bulk of the card's content.
          </p>
        </div>
      </div>
    </div>
  </section> -->

  <!-- START Q&aA SECTION -->
  <section class="py-16 main-bg">
    <div class="container mx-auto px-4 py-16">
      <div class="items-center flex flex-wrap">
        <div class="w-full md:w-6/12 ml-auto lg:px-12 md:px-4">
          <div class="">
            <h2 class="text-3xl font-semibold"> سوالات متداول </h2>

            <div class="w-full max-w-lg mx-auto mt-8">
              <div *ngFor="let item of questions; let i = index" class="mb-4">
                <button
                  class="w-full flex justify-between items-center px-6 py-4 bg-white border rounded-lg shadow-md hover:bg-gray-50 transition duration-300"
                  (click)="toggleAccordion(i)">
                  <h3 class="font-medium text-gray-800">{{ item.question }}</h3>
                  <svg [ngClass]="{ 'transform rotate-180': openAccordionIndex === i }"
                    class="w-5 h-5 text-gray-600 transition-transform duration-300" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
                <div class="overflow-hidden transition-all duration-500 ease-in-out" [ngStyle]="{
                  'max-height': openAccordionIndex === i ? '500px' : '0',
                  'padding': openAccordionIndex === i ? '1rem 1.5rem' : '0'
                }">
                  <p class="text-gray-700 text-sm bg-gray-50 rounded-b-lg shadow-inner transition-opacity duration-500">
                    {{ item.content }}
                  </p>
                </div>
              </div>
            </div>



          </div>
        </div>
        <div class="w-full md:w-5/12 mr-auto px-4 pt-24 md:pt-0"><img alt="..."
            src="../../../assets/img/Online Doctor-cuate.svg" class="max-w-full rounded-lg" style="transform: scale(1) perspective(1040px) rotateY(-11deg)
              rotateX(2deg) rotate(2deg);">
        </div>
      </div>
    </div>
  </section>
  <!-- END OF Q&A SECTION -->

  <!-- START LOGIN SECTION -->
  <section class="block py-24 bg-blueGray-800">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-6/12 xl:w-6/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <!-- <img alt="..." src="assets/img/blog-test.png" class="shadow-lg w-full" /> -->
            <div class="flex">
              <div class="mt-4 w-8/12">
                <h4 class="font-bold"> پزشک هستید؟ </h4>
                <p class="text-base text-blueGray-400 font-semibold">
                  پزشک عزیز، برای پیوستن به پزشکان سایت استاد ویزیت هم اکنون میتوانید ثبت نام کنید.
                </p>
              </div>
              <div class="w-4/12 flex justify-center">
                <img class="h-120-px" src="../../../assets/img/Ostadvisit-Doctor vector.svg" alt="">
              </div>
            </div>
            <div class="w-full mt-6 text-center">
              <a class="bg-primary text-white w-auto h-8 py-1 px-4 rounded outline-none focus:outline-none mb-1"
                type="button" href="http://doctor.ostadvisit.com/"> ثبت نام / ورود
            </a>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-6/12 xl:w-6/12 p-4">
          <div class="relative flex flex-col break-words bg-white rounded p-4 mb-6 xl:mb-0 shadow-lg">
            <!-- <img alt="..." src="assets/img/blog-test.png" class="shadow-lg w-full" /> -->
            <div class="flex">
              <div class="mt-4 w-8/12">
                <h4 class="font-bold"> کاربر هستید؟ </h4>
                <p class="text-base text-blueGray-400 font-semibold">
                  کاربر عزیز، برای استفاده از خدمات سایت استاد ویزیت هم اکنون میتوانید ثبت نام کنید.
                </p>
              </div>
              <div class="w-4/12 flex justify-center">
                <img class="h-120-px" src="../../../assets/img/Ostadvisit-User vector.svg" alt="">
              </div>
            </div>
            <div class="w-full mt-6 text-center">
              <button class="bg-primary text-white w-auto h-8 py-1 px-4 rounded outline-none focus:outline-none mb-1"
                type="button" [routerLink]="['/user/dashboard']"> ثبت نام / ورود
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END OF LOGIN SECTION -->

</main>
<app-footer></app-footer>